module.exports = __webpack_public_path__ + "static/media/Gymnastics - Hexagon.4c72f292.png";